/**
 * MaintenanceTypeService
 * Service for MaintenanceType lookup CRUD operations
 */
import { CrudService } from '../base/CrudService';
/** Service for MaintenanceType CRUD operations */
export class MaintenanceTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MaintenanceTypeService.DEFAULT_SERVICE_PATH,
            basePath: MaintenanceTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
MaintenanceTypeService.DEFAULT_SERVICE_PATH = 'assetmanagement';
MaintenanceTypeService.BASE_PATH = 'api/asset-maintenance-types';
//# sourceMappingURL=MaintenanceTypeService.js.map